export const tableName = {
  role: "role",
  permission: "permission",
  email_configuration: "tenantemailconfig",
  sms_configuration: "tenantsmsconfig",
  letter_head: "LetterHead",
  print_format: "PrintFormat",
  workflow_state_master: "Workflow_state_master",
  workflow_action: "Workflow_Action",
  workflow: "Workflow",
  import_management: "data_import",
  translations: "dynamic_translation",
  schema: "Schema",
  tenant_user: "TenantUser",
  socialConfigurationTable: "social_login_config",
};
